import * as tslib_1 from "tslib";
import DockingPluginBase from './DockingPluginBase';
import calculateDocking from './actions/calculateDocking';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
var DockingPlugin = /** @class */ (function (_super) {
    tslib_1.__extends(DockingPlugin, _super);
    function DockingPlugin(viewState) {
        var _this = _super.call(this, viewState) || this;
        _this.name = 'Docking';
        _this.onScrollContainerChanged = function (scrollContainer) {
            if (scrollContainer) {
                _this.tryStartObserver();
            }
            else {
                _this.tryStopObserver();
            }
        };
        _this.calculateDockingWithThrottling = function () {
            if (!_this.dockingThrottlingJob) {
                _this.dockingThrottlingJob = window.requestAnimationFrame(function () {
                    _this.dockingThrottlingJob = 0;
                    // Check if the editor is still before starting the docking calculation
                    if (_this.editor) {
                        _this.onCalculateDocking();
                    }
                });
            }
        };
        _this.onCalculateDocking = function () {
            var scrollContainer = _this.scrollAdapter.getScrollContainer();
            if (_this.viewState && scrollContainer && _this.dockingTriggerPart) {
                var newWidth = _this.dockingTriggerPart.offsetWidth;
                calculateDocking(_this.viewState, scrollContainer.scrollTop, scrollContainer.scrollLeft, scrollContainer.clientHeight, scrollContainer.offsetHeight, _this.dockingTriggerPart.offsetTop, _this.dockingTriggerPart.offsetHeight, newWidth);
            }
        };
        if (typeof MutationObserver == 'function') {
            _this.observer = new MutationObserver(_this.calculateDockingWithThrottling);
        }
        return _this;
    }
    DockingPlugin.prototype.initialize = function (editor) {
        _super.prototype.initialize.call(this, editor);
        this.scrollAdapter.addScrollEventListener(this.calculateDockingWithThrottling);
        this.tryStartObserver();
        lazySubscribeToResizeEvent.importAndExecute(this.calculateDockingWithThrottling);
    };
    DockingPlugin.prototype.dispose = function () {
        lazyUnsubscribeFromResizeEvent.importAndExecute(this.calculateDockingWithThrottling);
        this.tryStopObserver();
        this.scrollAdapter.removeScrollEventListener(this.calculateDockingWithThrottling);
        if (this.dockingThrottlingJob) {
            window.cancelAnimationFrame(this.dockingThrottlingJob);
            this.dockingThrottlingJob = 0;
        }
        _super.prototype.dispose.call(this);
    };
    DockingPlugin.prototype.tryStartObserver = function () {
        var scrollContainer = this.scrollAdapter.getScrollContainer();
        // TODO: Once we support compose projection window, need to make sure the observer code works well in projection window
        // We can check this.viewState.isPopout to know if this is in popout window
        if (this.observer && !this.observerConnected && this.editor && scrollContainer) {
            this.observer.observe(scrollContainer, {
                childList: true,
                attributes: true,
                subtree: true,
            });
            this.tryScrollIntoView();
            // Do an initial docking calculation
            this.calculateDockingWithThrottling();
            this.observerConnected = true;
        }
    };
    DockingPlugin.prototype.tryStopObserver = function () {
        if (this.observer && this.observerConnected) {
            this.observer.disconnect();
            this.observerConnected = false;
        }
    };
    return DockingPlugin;
}(DockingPluginBase));
export default DockingPlugin;
//# sourceMappingURL=DockingPlugin.js.map